export function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

/** Extract and title-case a display name from the user's first onboarding reply. */
export function extractDisplayName(firstReply: string): string {
  return firstReply
    .replace(/^(i'm|im|i am|my name is|they call me|it's|its|hey,?\s*i'm)\s+/i, '')
    .replace(/[.,!].*$/, '')
    .trim()
    .split(/\s+/)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

export function normalizeModuleLabelKey(label: string): string {
  return label.trim().replace(/\s+/g, ' ').toLowerCase();
}

export function parseBooleanFlag(value: string | null): boolean | null {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return null;
}


/** Derive a short title from the user's first message (up to 4 words, max 30 chars). */
export function deriveTitleFromMessage(content: string): string {
  const clean = content.trim().replace(/\s+/g, ' ');
  if (!clean) return 'New chat';

  const stripped = clean
    .replace(/^(can you |please |hey |hi |help me |I need |I want |let's |create |make |build |write |show me |give me |find |search |look up )/i, '')
    .replace(/^(a |an |the |my |our |some )/i, '')
    .trim();

  const words = (stripped || clean).split(' ');
  const titleWords = words.slice(0, 4);
  let title = titleWords.join(' ');
  if (title.length > 30) title = title.slice(0, 30).trimEnd();
  title = title.charAt(0).toUpperCase() + title.slice(1);
  return title || 'New chat';
}
